export const closeBtn = (color = 'white', size = '30') => {
	const svg = `
	<svg width="${size}" height="${size}" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M20 10L10 20" stroke="${color}" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M10 10L20 20" stroke="${color}" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>`;

	return svg;
};
